import { WordBank } from './index';

export const jamaicanWords: WordBank = {
  id: 'jamaican',
  name: 'Jamaican Patois',
  description: 'Common Jamaican Patois words and phrases',
  categories: ['greetings', 'food', 'expressions', 'supernatural', 'people', 'entertainment', 'behavior', 'characteristics'],
  words: [
    {
      word: "Irie",
      definition: "Everything is good and pleasant; feeling great",
      difficulty: "easy",
      category: "greetings",
      example: "Mi feeling irie today!"
    },
    {
      word: "Weh Yuh Ah Seh",
      definition: "How are you? What's going on?",
      difficulty: "easy",
      category: "greetings",
      example: "Weh yuh ah seh, my friend?"
    },
    {
      word: "Nyam",
      definition: "To eat or consume food",
      difficulty: "easy",
      category: "food",
      example: "Mi going to nyam some jerk chicken"
    },
    {
      word: "Boonoonoonoos",
      definition: "Something or someone extremely nice, beautiful, or special",
      difficulty: "hard",
      category: "expressions",
      example: "That dress is boonoonoonoos!"
    },
    {
      word: "Duppy",
      definition: "A ghost or spirit",
      difficulty: "medium",
      category: "supernatural",
      example: "The duppy story mek mi scared"
    },
    {
      word: "Pickney",
      definition: "A child or children",
      difficulty: "medium",
      category: "people",
      example: "The pickney dem playing in the yard"
    },
    {
      word: "Bashment",
      definition: "A big party or celebration",
      difficulty: "medium",
      category: "entertainment",
      example: "We going to a bashment tonight!"
    },
    {
      word: "Facety",
      definition: "Rude, disrespectful, or acting above one's position",
      difficulty: "medium",
      category: "behavior",
      example: "Don't be so facety with your elders"
    },
    {
      word: "Raatid",
      definition: "An exclamation of surprise or emphasis",
      difficulty: "hard",
      category: "expressions",
      example: "Raatid! Mi can't believe it!"
    },
    {
      word: "Tallawah",
      definition: "Strong, fearless, not to be underestimated despite small size",
      difficulty: "hard",
      category: "characteristics",
      example: "She small but she tallawah"
    }
  ]
}; 